// extracted by mini-css-extract-plugin
export var button = "footerMenu-module--button--3e1df";
export var footer_nav = "footerMenu-module--footer_nav--95872";
export var footer_nav_wrapper = "footerMenu-module--footer_nav_wrapper--9fd17";
export var navbar = "footerMenu-module--navbar--e6cd1";
export var submenu = "footerMenu-module--submenu--6034a";